import {useEffect} from 'react';

import {clarityId} from '~/shared/config';

import {createLogger} from '../logging';
import renderingForRobot from '../services/renderingForRobot';

const logger = createLogger('clarity');

/**
 * Conditionally initialize Microsoft Clarity for 10% of users
 * Only loads if clarityId is configured and user falls into the 10% sample
 */
const initClarity = () => {
  if (renderingForRobot || !clarityId || Math.random() >= 0.1) {
    return;
  }

  const loadClarity = () => {
    import('@microsoft/clarity')
      .then(clarityModule => {
        const clarity = clarityModule.default;
        clarity.init(clarityId!);
      })
      .catch((error: Error) => {
        logger.warn('Failed to initialize Microsoft Clarity:', error);
      });
  };

  if (typeof window !== 'undefined') {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(loadClarity, {timeout: 5000});
    } else {
      setTimeout(loadClarity, 100);
    }
  }
};

export const useInitClarity = () => {
  useEffect(() => {
    initClarity();
  }, []);
};
